export const EvddItemApiConst = {
    itemMerge: "evdd-item-api-item-merge",
};

export class EvddItemApi {
    public static itemMerge(details: any) {
        dispatchEvent(new CustomEvent(EvddItemApiConst.itemMerge, { detail: details }));
    }
}
